// import React, { useState, useRef } from 'react';
import variables from './image/variables.png';
// import LxPopover from '../../../components/LxPopover/LxPopover';
import * as EditorTypeAll from '../tinymce.d';
// import EditorVariable from '@/components/editor-variable';
// import TongyongRenyuan from '../../../assets/icons/tongyong-renyuan.svg';
// import TongyongQiye from '../../../assets/icons/tongyong-qiye.svg';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const Variables = (props: Props) => {
  console.log('Variables component loaded', props);
  // const onClick: MenuProps['onClick'] = ({ key }) => {
  //   document.body.click();
  //   // console.log(`Click on item ${key}`);
  //   editorInstance.insertContent(`${key}`);
  //   editorInstance.fire('setPlaceHolder', { value: null });
  // };

  // 变量菜单
  // const items: MenuProps['items'] = [
  //   {
  //     key: '{Name}',
  //     label: (
  //       <p className={classnames(style.varItem)}>
  //         <span className={classnames(style.title)}>
  //           <img src={TongyongRenyuan} />
  //           Name
  //         </span>
  //         <span className={classnames(style.code)}>{'{Name}'}</span>
  //       </p>
  //     ),
  //   },
  //   {
  //     key: '{Company name}',
  //     label: (
  //       <p className={classnames(style.varItem)}>
  //         <span className={classnames(style.title)}>
  //           <img src={TongyongQiye} />
  //           Company name
  //         </span>
  //         <span className={classnames(style.code)}>{'{Company name}'}</span>
  //       </p>
  //     ),
  //   },
  // ];

  // const btnRef = useRef(null);
  // const [visible, setVisible] = useState(false);
  // const [tipPos, setTipPos] = useState({
  //   top: 0,
  //   left: 0,
  // });
  // const variablesAction = (event: React.MouseEvent<HTMLDivElement>) => {
  //   const elemRect = (event.target as Element).getBoundingClientRect();
  //   setVisible(true);
  //   setTipPos({
  //     top: document.documentElement.scrollTop + elemRect.top - 15,
  //     left: document.documentElement.scrollLeft + elemRect.left,
  //   });
  //   event.stopPropagation();
  //   editorInstance.insertContent('变量】】】】');
  // };

  return (
    <>
      <div className="inline-flex rounded-[4px] cursor-pointer hover:bg-[#E5E5E5] p-0">
        {/* <EditorVariable trigger={['click']} menu={{ onClick }} placement="topLeft">
          <img width="96px" height="28px" src={variables} />
        </EditorVariable> */}
        <img width="96px" height="28px" src={variables} />
      </div>
      {/* <LxPopover
        top={tipPos.top}
        left={tipPos.left}
        resetStyle={{ zIndex: 9999 }}
        visible={visible}
        setVisible={setVisible}
        acceptTopBottom
      >
        <div className={classnames(style.variablesBoxWrap, style.fontCommaBoxWrap)}>变量</div>
      </LxPopover> */}
    </>
  );
};

export default Variables;
